<template>


  <!-- ////////////// -->
  <!-- Physical Prize Popup -->
  <!-- ////////////// -->
  <div data-backdrop="static" data-keyboard="false" class="modal fade prize"
       id="physical_prize_popup" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <button type="button" @click="this.closeModal" class="close" data-dismiss="modal"
                aria-label="Close">
          <img src="static/img/millen_images/popup-close.svg">
        </button>
        <div v-for="(item, index) in physical">
          <div v-if="index === prizeId">
            <div class="modal-header">
              <h5 class="modal-title">{{ item.name }}</h5>
            </div>
            <div class="modal-body">
              <img :src="item.image" class="prize">

              <div class="prize_drop">
                <p>{{ item.quantity }}</p>
              </div>
            </div>
            <div class="modal-footer">
              <p>
                {{ item.description }}
              </p>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

import {mapGetters, mapMutations} from 'vuex'
import gtm_analytics from "../../common/mixin/gtm_analytics";

export default {
  name: 'PhysicalPrize',
  mixins: [
    gtm_analytics
  ],
  data() {
    return {
      physical: [],
      prizeId: null

    }
  },
  mounted() {
    $('#physical_prize_popup').modal('show')
    this.prizeId = this.getModalPhysicalPrizeId
    this.physical = this.physicalPrizeResponse

    this.pushPopUp('Popup visit','Physical Reward Pop Up')
  },
  computed: {
    ...mapGetters([
      'physicalPrizeResponse',
      'isPhysicalPrizeModalOpen',
      'getModalPhysicalPrizeId'
    ])
  },
  methods: {
    ...mapMutations([
      'updatePhysicalPrizeResponse',
      'updateModalPhysicalPrizeId',
      'updatePhysicalPrizeModal'

    ]),
    closeModal() {
      $('#physical_prize_popup').modal('hide')
      this.updatePhysicalPrizeModal(false)
      this.updateModalPhysicalPrizeId('')
    }
  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/modals/PhysicalPrize.vue